<script setup lang="ts">

import { faXmark } from '@fortawesome/pro-solid-svg-icons'

import { AppText } from '@shared/ui/typography'
import { DropZoneArea } from '@shared/ui/other'
import { CardAdmin } from '@shared/ui/cards'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useImportSalesTax, SALES_TAX_ACCEPT } from '../../../model/tools/sales-tax/import-sales-tax.hook'

defineOptions({
  name: 'ImportSalesTaxUploader',
})

const {
  refFile,
  refIsUploading,
  refProgress,
  refError,
  selectFiles,
  submit,
  reset,
} = useImportSalesTax()
</script>

<template>
  <CardAdmin
    title="Import sales tax rates"
    subtitle="Upload a CSV/TXT file to replace all sales tax rates."
  >
    <template #header>
      <BtnPrimary
        :text="refIsUploading ? 'Importing…' : 'Import'"
        color="blue"
        :disabled="!refFile || refIsUploading"
        @click="submit"
      />
    </template>

    <div class="import-sales-tax">
      <DropZoneArea
        :accept="SALES_TAX_ACCEPT"
        :multiple="false"
        :disabled="refIsUploading"
        title="Drag & drop a sales tax file here"
        browse-text="Browse file"
        @files="selectFiles"
      />

      <div
        v-if="refFile"
        class="import-sales-tax__file"
      >
        <AppText name="body2-medium">
          {{ refFile.name }}
        </AppText>
        <BtnIcon
          :icon="faXmark"
          view="transparent"
          :disabled="refIsUploading"
          @click="reset"
        />
      </div>

      <AppText
        v-if="refIsUploading"
        name="body2"
        color="slate-500"
      >
        Uploading… {{ refProgress }}%
      </AppText>

      <AppText
        v-if="refError"
        name="body2"
        color="red-500"
      >
        {{ refError }}
      </AppText>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./ImportSalesTaxUploader.scss" />
